import { Copyable } from 'routes/Debug/Copyable';
import { Button } from 'components/Input/Button';
import Typography from 'components/Typography';
import { ACTIONS } from 'constants/hook';

import { useAppConfig } from 'hooks/appConfig';
import { useAuthentication } from 'hooks/authentication';
import { useChatContext } from 'hooks/chatContext';
import { useConversation } from 'hooks/conversation';
import { useCustomer } from 'hooks/customer';
import { useView } from 'hooks/view';

import { ReactNode, useState } from 'react';

import { COOKIE_KEY, LOCAL_STORAGE_KEY, SESSION_STORAGE_KEY } from 'constants/browserCache';
import { useNavigate } from 'react-router-dom';
import { deleteCookieItem, deleteLocalStorage, deleteSessionStorage } from 'utils/browserCache';
import { StorageKeysType } from 'utils/browserCache/types';
import { CookieDebug, LocalStorageDebug, SessionStorageDebug } from './BrowserStorage';
import { Container, Grid, LCol, RCol, Row } from './Debug.styles';
import {
  AppConfigDebug,
  AuthenticationDebug,
  ChatContextDebug,
  ConversationDebug,
  CustomerDebug,
  ViewDebug,
} from './States';

const GridItem = ({ lCol, rCol }: { lCol: ReactNode; rCol: ReactNode }) => {
  return (
    <Row>
      <LCol>{lCol}</LCol>
      <RCol>{rCol}</RCol>
    </Row>
  );
};

const Debug = () => {
  const navigate = useNavigate();
  const { dispatchAppConfigAction } = useAppConfig();
  const { dispatchAuthenticationAction } = useAuthentication();
  const { dispatchChatContextAction } = useChatContext();
  const { dispatchConversationAction } = useConversation();
  const { dispatchCustomerAction } = useCustomer();
  const { dispatchViewAction } = useView();

  const [refresh, setRefresh] = useState(false);
  return (
    <>
      <Container>
        <Button
          fullwidth
          size='small'
          variant='primary'
          priority='secondary'
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Container>

      <Container>
        <Grid>
          <Typography variant='heading'>React Contexts</Typography>

          <AppConfigDebug />
          <AuthenticationDebug />
          <ChatContextDebug />
          <ConversationDebug />
          <CustomerDebug />
          <ViewDebug />

          <Typography variant='heading'>Local Storage</Typography>
          <LocalStorageDebug />

          <Typography variant='heading'>Session Storage</Typography>
          <SessionStorageDebug />

          <Typography variant='heading'>Cookies</Typography>
          <CookieDebug />

          <Button
            size='xs'
            fullwidth
            onClick={() => {
              setRefresh(!refresh);
            }}
          >
            Refresh
          </Button>
          <Button
            size='xs'
            fullwidth
            variant='destructive'
            onClick={() => {
              dispatchAppConfigAction({ type: ACTIONS.RESET });
              dispatchAuthenticationAction({ type: ACTIONS.RESET });
              dispatchChatContextAction({ type: ACTIONS.RESET });
              dispatchConversationAction({ type: ACTIONS.RESET });
              dispatchCustomerAction({ type: ACTIONS.RESET });
              dispatchViewAction({ type: ACTIONS.RESET });
            }}
          >
            Clear All States
          </Button>
          <Button
            size='xs'
            fullwidth
            variant='destructive'
            onClick={() => {
              deleteLocalStorage(Object.values(LOCAL_STORAGE_KEY) as StorageKeysType[]);
              deleteSessionStorage(Object.values(SESSION_STORAGE_KEY) as StorageKeysType[]);
            }}
          >
            Clear Browser Storage
          </Button>
          <Button
            size='xs'
            fullwidth
            variant='destructive'
            onClick={() => {
              Object.values(COOKIE_KEY).forEach((cookie) => deleteCookieItem(cookie));
            }}
          >
            Clear Cookies
          </Button>
        </Grid>
      </Container>
    </>
  );
};
export default Debug;
